// extracted by mini-css-extract-plugin
export default {"title":"style_title__cTcTW","desc":"style_desc__oxS4n"};